import React, { useEffect } from 'react';
import NodeStats from '../components/NodeStats';
import NodeLeaderboard from '../components/NodeLeaderboard';
import NodeGovernance from '../components/NodeGovernance';
import NodeEarningsCalculator from '../components/NodeEarningsCalculator';
import NodeApplicationWithModals from '../components/NodeApplicationWithModals'; // Updated import
import FAQSection from '../components/FAQSection';

const NodePage = () => {
  // Scroll to hash ID if present
  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Delay slightly to ensure all components are rendered
      setTimeout(() => {
        const id = window.location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main className="node-page">
      <div className="node-hero">
        <div className="container">
          <h1 className="node-hero-title">Become an <span>Aledger Node Operator</span></h1>
          <p className="node-hero-subtitle">
            Apply to become a team leader, build your network, and earn multiple revenue streams while helping to shape the future of the Aledger ecosystem.
          </p>
          <div className="btn-group">
            <a href="#node-application" className="btn">Apply Now</a>
            <a href="#node-calculator" className="btn btn-outline">Estimate Earnings</a>
          </div>
        </div>
      </div>
{/*       
      <NodeStats />
      <NodeLeaderboard />
      <NodeGovernance />
      <NodeEarningsCalculator /> */}
      <NodeApplicationWithModals /> {/* Using our new component */}
      <FAQSection />
    </main>
  );
};

export default NodePage;
